// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== UI Preferences: tema, densita tabella, sync indicator ======
// Persistito su localStorage (chiave 'mase-ui'). Stato globale leggero,
// niente framework.

const UI_PREFS_KEY = 'mase-ui-prefs';

function loadUiPrefs() {
  try {
    const raw = localStorage.getItem(UI_PREFS_KEY);
    if (!raw) return { theme: 'light', density: 'cozy', presentation: false };
    const parsed = JSON.parse(raw);
    const d = parsed.density;
    return {
      theme: parsed.theme || 'light',
      density: d === 'compact' || d === 'ultra' || d === 'cozy' ? d : 'cozy',
      presentation: !!parsed.presentation
    };
  } catch {
    return { theme: 'light', density: 'cozy', presentation: false };
  }
}

function saveUiPrefs(prefs) {
  try {
    localStorage.setItem(UI_PREFS_KEY, JSON.stringify(prefs));
  } catch {}
}

function densityLabelFor(d) {
  return d === 'ultra' ? 'Ultra-compatta' : d === 'compact' ? 'Compatta' : 'Comoda';
}
function nextDensity(d) {
  if (d === 'cozy') return 'compact';
  if (d === 'compact') return 'ultra';
  return 'cozy';
}

function applyUiPrefs(prefs) {
  const root = document.documentElement;
  if (prefs.theme === 'dark') root.setAttribute('data-theme', 'dark');
  else root.removeAttribute('data-theme');
  if (prefs.density === 'compact') root.setAttribute('data-density', 'compact');
  else if (prefs.density === 'ultra') root.setAttribute('data-density', 'ultra');
  else root.removeAttribute('data-density');

  // G5: modalità presentazione (schermo grande per riunioni)
  if (prefs.presentation) root.setAttribute('data-presentation', '');
  else root.removeAttribute('data-presentation');
  const presLabel = document.getElementById('presentationLabel');
  if (presLabel) presLabel.textContent = prefs.presentation ? 'On' : 'Off';
  const btnPres = document.getElementById('btnTogglePresentation');
  if (btnPres) btnPres.classList.toggle('is-on', !!prefs.presentation);

  // Aggiorna label nel menu strumenti
  const themeLabel = document.getElementById('themeLabel');
  if (themeLabel) themeLabel.textContent = prefs.theme === 'dark' ? 'Scuro' : 'Chiaro';
  const densityLabel = document.getElementById('densityLabel');
  if (densityLabel) densityLabel.textContent = densityLabelFor(prefs.density);

  const btnTheme = document.getElementById('btnToggleTheme');
  if (btnTheme)
    btnTheme.title = prefs.theme === 'dark' ? 'Passa a tema chiaro' : 'Passa a tema scuro';
  const btnDens = document.getElementById('btnToggleDensity');
  if (btnDens)
    btnDens.title = `Cambia densità (ora: ${densityLabelFor(prefs.density)}) — click per "${densityLabelFor(nextDensity(prefs.density))}"`;
}

const _uiPrefs = loadUiPrefs();
// Applica subito (prima del DOMContentLoaded per evitare flash)
applyUiPrefs(_uiPrefs);

function toggleTheme() {
  _uiPrefs.theme = _uiPrefs.theme === 'dark' ? 'light' : 'dark';
  saveUiPrefs(_uiPrefs);
  applyUiPrefs(_uiPrefs);
  // Notifica i grafici Chart.js per ridisegno con colori nuovi
  if (typeof refreshCharts === 'function') refreshCharts();
}

function toggleDensity() {
  _uiPrefs.density = nextDensity(_uiPrefs.density);
  saveUiPrefs(_uiPrefs);
  applyUiPrefs(_uiPrefs);
}

function togglePresentation() {
  _uiPrefs.presentation = !_uiPrefs.presentation;
  saveUiPrefs(_uiPrefs);
  applyUiPrefs(_uiPrefs);
  if (typeof refreshCharts === 'function') refreshCharts();
  if (typeof toast === 'function')
    toast(
      _uiPrefs.presentation ? 'Modalità presentazione attiva' : 'Modalità presentazione disattivata'
    );
}

// ===== Sync indicator =====
let _lastSyncAt = null;
let _syncTimer = null;

function setSyncState(state) {
  // state: 'ok' | 'refreshing' | 'error'
  const el = document.getElementById('syncIndicator');
  if (!el) return;
  el.classList.remove('refreshing', 'error');
  if (state === 'refreshing') el.classList.add('refreshing');
  else if (state === 'error') el.classList.add('error');
  if (state === 'ok') {
    _lastSyncAt = Date.now();
    updateSyncLabel();
  }
}

function updateSyncLabel() {
  const el = document.getElementById('syncIndicator');
  if (!el || !_lastSyncAt) return;
  const label = el.querySelector('.sync-label');
  if (!label) return;
  const sec = Math.floor((Date.now() - _lastSyncAt) / 1000);
  if (el.classList.contains('refreshing')) {
    label.textContent = 'sincronizzazione…';
    return;
  }
  if (el.classList.contains('error')) {
    label.textContent = 'errore sync';
    return;
  }
  if (sec < 10) label.textContent = 'sincronizzato ora';
  else if (sec < 60) label.textContent = `sincronizzato ${sec}s fa`;
  else if (sec < 3600) label.textContent = `sincronizzato ${Math.floor(sec / 60)}m fa`;
  else label.textContent = `sincronizzato ${Math.floor(sec / 3600)}h fa`;
}

if (!_syncTimer) _syncTimer = setInterval(updateSyncLabel, 10000);

async function refreshDataNow() {
  setSyncState('refreshing');
  // Skeleton sulla tabella Clienti durante il refresh manuale
  const tbody = document.getElementById('tbodyClienti');
  if (tbody && typeof skeletonRows === 'function') skeletonRows(tbody, 7, 8);
  try {
    await loadStateFromSupabase();
    setSyncState('ok');
    renderAll();
    if (typeof removeInlineError === 'function') removeInlineError('clienti');
    toast('Dati ricaricati');
  } catch (e) {
    console.error(e);
    setSyncState('error');
    if (typeof showInlineError === 'function') {
      showInlineError('clienti', e.message || String(e), {
        title: 'Errore aggiornamento dati',
        onRetry: refreshDataNow
      });
    } else {
      toast('Errore aggiornamento: ' + (e.message || e));
    }
  }
}

// ===== Sidebar mobile =====
function toggleSidebar(forceOpen) {
  const sb = document.querySelector('.sidebar');
  const ov = document.getElementById('sidebarOverlay');
  if (!sb || !ov) return;
  const open = forceOpen === undefined ? !sb.classList.contains('open') : !!forceOpen;
  sb.classList.toggle('open', open);
  ov.classList.toggle('show', open);
}

// ===== Toolbar tools dropdown =====
function toggleToolsMenu(forceOpen) {
  const wrap = document.querySelector('.tools-wrap');
  const btn = document.getElementById('btnTopbarTools');
  if (!wrap || !btn) return;
  const open = forceOpen === undefined ? !wrap.classList.contains('open') : !!forceOpen;
  wrap.classList.toggle('open', open);
  btn.setAttribute('aria-expanded', String(open));
}

// Wire-up
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('btnToggleTheme')?.addEventListener('click', toggleTheme);
  document.getElementById('btnToggleDensity')?.addEventListener('click', toggleDensity);
  document.getElementById('btnTogglePresentation')?.addEventListener('click', togglePresentation);
  document.getElementById('btnRefreshNow')?.addEventListener('click', refreshDataNow);
  document.getElementById('btnBurger')?.addEventListener('click', () => toggleSidebar());
  document.getElementById('sidebarOverlay')?.addEventListener('click', () => toggleSidebar(false));
  document
    .querySelectorAll('.nav-item')
    .forEach((n) => n.addEventListener('click', () => toggleSidebar(false)));

  // Tools dropdown: apri/chiudi col bottone, chiudi cliccando fuori
  document.getElementById('btnTopbarTools')?.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleToolsMenu();
  });
  document.addEventListener('click', (e) => {
    const wrap = document.querySelector('.tools-wrap');
    if (!wrap || !wrap.classList.contains('open')) return;
    if (!wrap.contains(/** @type {Node} */ (e.target))) toggleToolsMenu(false);
  });

  // Dashboard: ricorda quali blocchi richiudibili sono aperti/chiusi
  document.querySelectorAll('details.dash-fold').forEach((d) => {
    const key = 'mase-fold-' + d.id;
    if (localStorage.getItem(key) === 'closed') d.open = false;
    d.addEventListener('toggle', () => {
      try {
        localStorage.setItem(key, d.open ? 'open' : 'closed');
      } catch (_) {
        /* ignore */
      }
      if (d.open && typeof refreshCharts === 'function') refreshCharts();
    });
  });

  // Applica dopo DOM ready (per i pulsanti)
  applyUiPrefs(_uiPrefs);
});

// ===== Boot splash hide =====
function hideBootSplash() {
  const splash = document.getElementById('bootSplash');
  if (!splash) return;
  splash.classList.add('fadeout');
  setTimeout(() => splash.remove(), 350);
}

// ===== Menu a tendina generico ([data-menu] / [data-menu-btn] / .menu-pop) =====
// Mount-safe e CSP-safe: un solo handler delegato su document, valido anche per
// i menu iniettati dalle viste lazy. Apre/chiude col bottone, chiude cliccando
// fuori o su una voce.
document.addEventListener('click', (e) => {
  const btn = e.target.closest?.('[data-menu-btn]');
  const insidePop = e.target.closest?.('.menu-pop');
  document.querySelectorAll('.menu.open').forEach((m) => {
    if (m.contains(e.target) && (btn || insidePop)) return;
    m.classList.remove('open');
    m.querySelector('[data-menu-btn]')?.setAttribute('aria-expanded', 'false');
  });
  if (btn) {
    e.stopPropagation();
    const menu = btn.closest('.menu');
    if (menu) {
      const open = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
    }
  } else if (insidePop) {
    const menu = insidePop.closest('.menu');
    if (menu) {
      menu.classList.remove('open');
      menu.querySelector('[data-menu-btn]')?.setAttribute('aria-expanded', 'false');
    }
  }
});

// Tastiera per i menù: Esc chiude (generici + strumenti), frecce per scorrere le voci.
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const open = document.querySelector('.menu.open');
    if (open) {
      open.classList.remove('open');
      const b = open.querySelector('[data-menu-btn]');
      b?.setAttribute('aria-expanded', 'false');
      if (b instanceof HTMLElement) b.focus();
    }
    if (document.querySelector('.tools-wrap.open')) toggleToolsMenu(false);
    return;
  }
  const open = document.querySelector('.menu.open');
  if (!open) return;
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault();
    const items = [...open.querySelectorAll('.menu-item')];
    if (!items.length) return;
    const cur = items.indexOf(document.activeElement);
    let next = e.key === 'ArrowDown' ? cur + 1 : cur - 1;
    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;
    items[next].focus();
  }
});

Object.assign(globalThis, {
  setSyncState,
  hideBootSplash,
  refreshDataNow,
  toggleTheme,
  toggleDensity,
  togglePresentation,
  toggleSidebar
});
export {};
